import { memo, useMemo, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { TRADE_TABLES } from 'shared-modules/constants';
import { changeSelectedPortfolioAutoTradeTable, saveSelectedTableRows } from '../../../../../../../../redux/actions';
import { Tabs } from '../../../../../../../../components';
import { TableRefProvider } from '../../../../../../../../contexts';
import TableExecutions from '../TableExecutions/TableExecutions';
import TableOrders from '../TableOrders/TableOrders';
import TablePositions from '../TablePositions/TablePositions';
import { TableWrapper } from './TableWrapper';
import styles from './tableHeader.module.scss';

const TableHeader = ({ id, serviceId }) => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.webPortfolio.selectedTable);
  const [isPositionSelectMode, setIsPositionSelectMode] = useState(false);

  const enterPositionSelectMode = useCallback(() => {
    setIsPositionSelectMode(true);
  }, []);

  const exitPositionSelectMode = useCallback(() => {
    setIsPositionSelectMode(false);
    dispatch(saveSelectedTableRows({ rows: [] }));
  }, [dispatch]);

  const changeActiveTab = useCallback(
    (tableId) => {
      const nextTabId = Number(tableId);
      if (nextTabId !== TRADE_TABLES.POSITIONS.ID && isPositionSelectMode) {
        exitPositionSelectMode();
      }
      dispatch(changeSelectedPortfolioAutoTradeTable({ tableId: nextTabId }));
    },
    [dispatch, isPositionSelectMode, exitPositionSelectMode],
  );

  const tabItems = useMemo(() => {
    return [
      {
        id: TRADE_TABLES.ORDERS.ID,
        label: '注文設定',
        children: (
          <TableWrapper serviceId={serviceId}>
            <TableOrders id={id} serviceId={serviceId} />
          </TableWrapper>
        ),
      },
      {
        id: TRADE_TABLES.EXECUTIONS.ID,
        label: '約定照会',
        children: (
          <TableWrapper serviceId={serviceId}>
            <TableExecutions id={id} serviceId={serviceId} />
          </TableWrapper>
        ),
      },
      {
        id: TRADE_TABLES.POSITIONS.ID,
        label: '建玉照会',
        children: (
          <TableWrapper
            serviceId={serviceId}
            isPositionSelectMode={isPositionSelectMode}
            onEnterPositionSelectMode={enterPositionSelectMode}
            onExitPositionSelectMode={exitPositionSelectMode}
          >
            <TablePositions id={id} serviceId={serviceId} isSelectMode={isPositionSelectMode} />
          </TableWrapper>
        ),
      },
    ];
  }, [id, serviceId, isPositionSelectMode, enterPositionSelectMode, exitPositionSelectMode]);

  return (
    <TableRefProvider>
      <Tabs containerClassName={styles.tabs} items={tabItems} activeKey={activeTab} onChange={changeActiveTab} />
    </TableRefProvider>
  );
};

TableHeader.propTypes = {
  id: PropTypes.string.isRequired,
  serviceId: PropTypes.string.isRequired,
};

export default memo(TableHeader);
